import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { loader } from 'graphql.macro';
import { ApolloClientCache } from 'common-types';
import { logger } from 'logging-utils';
import {
  ArtifactTopFiilter,
  FetchArtifactsTopFiltersInput,
} from '../../types/artifacts-type';

const getArtifactsTopFilters = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return {
    execute: async (getArtifactsInput: FetchArtifactsTopFiltersInput) => {
      try {
        const results = await client.query<ArtifactsTopFiltersOutput>({
          query,
          fetchPolicy: ApolloClientCache.NoCache,
          variables: { getArtifactsInput },
        });
        if (!results.data) return null;
        return results.data.getArtifactsTopFilters;
      } catch (e) {
        logger.error('Failed to fetch artifacts top filters', e);
        return null;
      }
    },
  };
};

const query = loader('./get-artifacts-top-filters.gql');

export interface ArtifactsTopFiltersOutput {
  getArtifactsTopFilters: ArtifactTopFiilter[];
}

export default getArtifactsTopFilters;
